import React, { Component } from 'react';
import { Link } from 'react-router-dom';
//import AnchorLink from 'react-anchor-link-smooth-scroll';
import $ from 'jquery';

class Landing extends Component {
    constructor(props){
        super(props);

        this.state = {
            height:0
        }

        this.handeClick = this.handeClick.bind(this);
    }

    componentDidMount(){
        const height = $("#pt").height();
        this.setState({height});


        window.Pts.quickStart( "#pt", "#123" );

        //Check for mobile devices
        function DeviceCheck(){
            var check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            return check;
        };
        //Disable pointer events for mobile device to enable scrolling
        if(DeviceCheck()){
            $("#pt").css("pointer-events","none");
        }

        (function() {
     
            var pairs = [];
            window.space.add({
                start:( bound ) => {
                    let r = window.space.size.minValue().value/2;
                    // create 200 lines
                    for (let i=0; i<100; i++) {
                        let ln = new window.Group(window.Pt.make(2, r, true), window.Pt.make(2, -r, true) );
                        ln.moveBy(window.space.center).rotate2D(i*Math.PI/100, window.space.center );
                        pairs.push(ln );
                    }
                },
           
                animate: (time, ftime) => {     
                    for (let i=0, len=pairs.length; i<len; i++) {
                        // rotate each line by 0.1 degree and check collinearity with pointer
                        let ln = pairs[i];
                        ln.rotate2D(window.Const.one_degree/30, window.space.center );
                        let collinear = window.Line.collinear( ln[0], ln[1], window.space.pointer, 0.1);
                
                        if (collinear) {
                            //form.stroke("#fff").line(ln);
                        } else {
                            // if not collinear, color the line based on whether the pointer is on left or right side
                            let side = window.Line.sideOfPt2D( ln, window.space.pointer );
                            window.form.stroke( (side<0) ? "rgba(255,255,0,.1)" : "rgba(0,255,255,.1)" ).line( ln );
                        }
                        window.form.fillOnly("rgba(255,255,255,0.8").points( ln, 0.5);
                    }
                }
            });
            window.space.bindMouse().bindTouch().play();
        })();

    }

    handeClick(){
        window.scrollTo(0, this.state.height);
    }

    render() {

        return (

            <div id="landingPage">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-4"></div>
                        <div class="col-4">
                            <h3 id="landingText">
                                Hello, I'm <span id="landingMyName">Stivan Kitchoukov</span>.<br></br> I'm a Software Engineer.
                                <br></br><br></br>

                                    <Link id="landingPage_quote" class="btn btn-outline-danger" to="/Contact" onClick={this.handeClick}>
                                        Get Quote
                                    </Link>

                                    <br></br><br></br>
                                    <button id="landingPage_button" onClick={this.handeClick}>
                                        <i id="landingPage_icons" class="fa fa-angle-double-down"></i>
                                    </button>

                            </h3>
                    
                        </div>
                        <div class="col-4"></div>
                    </div>
                </div>

                <div id="pt" ></div>
            </div>
        );
    }
}

export default Landing;


// WEBPACK FOOTER //
// ./src/components/landingComponent/landing.js